import React, { useState, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import './SignageCreatePlaylist.css'
import AddLink from './AddLink'
import AddNewPlaylist from './AddNewPlaylist'
import ImportFromCanva from './ImportFromCanva'
import Clock from '../../../components/SignagePlus/Clock';
import Weather from '../../../components/SignagePlus/Weather';
import Calendar from '../../../components/SignagePlus/Calendar';
import FooterActions from '../../../components/SignagePlus/FooterActions'
import Toast from '../../../components/Toast/Toast';
import PlaylistTabBar from '../../../components/SignagePlus/PlaylistTabBar';
import PlaylistHeaderActions from '../../../components/SignagePlus/PlaylistHeaderActions';
import PlaylistPanelList from '../../../components/SignagePlus/PlaylistPanelList';
import RenderTabContent from '../../../components/SignagePlus/RenderTabContent';
import { SIGNAGE_MEDIA } from '../../../utils/constants'
import API from '../../../utils/API'
import constants from "../../../utils/constants";
import { setUnsavedChanges } from '../../../store/signage';
import { useNavigate } from "react-router-dom";
import Save from '../../../assets/icons/signage-plus/save.svg';
import NotificationModal from '../../../components/MessageManager/NotificationModal';

const TABS = { playlists: 'PLAYLISTS', [SIGNAGE_MEDIA.MEDIA_CATEGORY.MEDIA]: 'MEDIA', [SIGNAGE_MEDIA.MEDIA_CATEGORY.WIDGET]: 'WIDGETS', [SIGNAGE_MEDIA.MEDIA_CATEGORY.CANVA]: 'CANVA', [SIGNAGE_MEDIA.MEDIA_CATEGORY.LINK]: 'LINKS' }
const widget = [
  { "subcategory": SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CALENDAR, "text": "Calendar" },
  { "subcategory": SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CLOCK, "text": "Clock" },
  { "subcategory": SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.WEATHER, "text": "Weather" }
]

function SignageCreatePlaylist(props) {
  const [activeTab, setActiveTab] = useState('playlists')
  const [playlistData, setPlaylistData] = useState([])
  const [mediaData, setMediaData] = useState([])
  const [canvaData, setCanvaData] = useState([])
  const [widgetData, setWidgetData] = useState([])
  const [linkData, setLinkData] = useState([])
  const [selectedPlaylistId, setSelectedPlaylistId] = useState('');
  const [playlistItems, setPlaylistItems] = useState([]);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [renameId, setRenameId] = useState(null);
  const [renameValue, setRenameValue] = useState('');
  const [draggedItem, setDraggedItem] = useState(null);
  const [playlistOrderMap, setPlaylistOrderMap] = useState({});
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const [playlistHeader, setPlaylistHeader] = useState({});
  const [linkItem, setLinkItem] = useState(null);
  const [isCanvaAuthenticated, setIsCanvaAuthenticated] = useState(false);
  const [canvaUrl, setCanvaUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [notificationProps, setNotificationProps] = useState({
    icon: Save,
    message: 'CONFIRM_SAVE',
    description: 'CONFIRM_SAVE_BEFORE_EXIT',
    primaryButtonText: 'CONTINUE',
  });
  const modalRef = useRef(null);

  const navigate = useNavigate();
  const { user } = props;
  const permissionIds = user.permissions.map((permission) => permission.id);
  if (!(permissionIds.includes(constants.permissionIds.signagePlusOwner) || permissionIds.includes(constants.permissionIds.signagePlusTeacher))) {
    navigate('/forbidden');
  }
  const closeModal = (modalId) => {
    const modal = document.getElementById(modalId);
    if (modal) {
      const closeButton = modal.querySelector(
        '.btn-close, [data-bs-dismiss="modal"]'
      );
      if (closeButton) {
        closeButton.click();
      }
    }
  };

  // Initialize from URL params: tab and playlist; default playlist to first if missing/invalid
  useEffect(() => {
    const initializeFromUrl = async () => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const initialTab = urlParams.get('tab');
      const initialPlaylistId = urlParams.get('playlist');

      if (initialTab === SIGNAGE_MEDIA.MEDIA_CATEGORY.CANVA) {
        setActiveTab(initialTab);
      }

      try {
        const res = await API.getPlaylists();
        const playlists = Array.isArray(res?.data) ? res.data : [];
        if (initialPlaylistId && playlists.some(pl => pl.id === initialPlaylistId)) {
          setSelectedPlaylistId(initialPlaylistId);
        } else {
          setSelectedPlaylistId(playlists[0]?.id || '');
        }
      } catch (e) {
        console.error('Error initializing playlist from URL:', e);
      }

      setIsInitialized(true);
    };

    initializeFromUrl();
  }, [])

  const fetchTabData = async () => {
    const currentTab = activeTab; // Capture the current tab to prevent race conditions
    setIsLoading(true);
    try {
      let res;
      if (currentTab === 'playlists') {
        res = await API.getPlaylists();
      } else if (currentTab === SIGNAGE_MEDIA.MEDIA_CATEGORY.CANVA) {
        // Only fetch Canva data if authenticated, otherwise return empty array
        if (isCanvaAuthenticated) {
          try {
            res = await API.getCanvaFolders();
          } catch (error) {
            console.error('Error fetching Canva folders');
            // If we get a 401 error, the user's authentication has expired
            if (error.response && error.response.status === 401) {
              setIsCanvaAuthenticated(false);
            }
            res = { data: [] };
          }
        } else {
          res = { data: [] };
        }
      } else {
        res = await API.getMediasByCategory(currentTab);
      }
      
      // Check if the tab has changed while we were fetching
      if (currentTab !== activeTab) {
        return; // Don't update state if tab changed during fetch
      }
      
      if (currentTab === SIGNAGE_MEDIA.MEDIA_CATEGORY.WIDGET) {
        const mergedWidget = widget.map((item) => {
          const match = res.data.find((resItem) => resItem.subcategory === item.subcategory);
          if (match) {
            return { ...item, ...match };
          }
          return item;
        });
        setWidgetData(mergedWidget);
        return;
      }

      // Update the appropriate state based on the current tab
      switch (currentTab) {
        case 'playlists':
          setPlaylistData(res.data);
          break;
        case SIGNAGE_MEDIA.MEDIA_CATEGORY.MEDIA:
          setMediaData(res.data);
          break;
        case SIGNAGE_MEDIA.MEDIA_CATEGORY.CANVA:
          setCanvaData(res.data);
          break;
        case SIGNAGE_MEDIA.MEDIA_CATEGORY.LINK:
          setLinkData(res.data);
          break;
        default:
          break;
      }
    } catch (error) {
      console.error('Error fetching tab data:', error);
      // Only update state if tab hasn't changed
      if (currentTab === activeTab) {
        switch (currentTab) {
          case 'playlists':
            setPlaylistData([]);
            break;
          case SIGNAGE_MEDIA.MEDIA_CATEGORY.MEDIA:
            setMediaData([]);
            break;
          case SIGNAGE_MEDIA.MEDIA_CATEGORY.CANVA:
            setCanvaData([]);
            break;
          case SIGNAGE_MEDIA.MEDIA_CATEGORY.LINK:
            setLinkData([]);
            break;
          default:
            break;
        }
      }
    } finally {
      // Only update loading state if tab hasn't changed
      if (currentTab === activeTab) {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (isInitialized) {
      fetchTabData();
    }
  }, [isInitialized]);


  useEffect(()=>{
    const fetchCanvaUrl = async () => {
    try{
      const canvaRes = await API.getCanvaAuthenticateUrl();
      setCanvaUrl(canvaRes.data);
    } catch (e) {
      console.error(e);
    }
  }
    fetchCanvaUrl();
    modalRef.current = new window.bootstrap.Modal(document.getElementById('notificationModal'));
  }, []);

  useEffect(() => {
    let timeoutId;

    const fetchCanvaAuthenticate = async () => {
      try {
        await API.CanvaAuthenticate();
        setIsCanvaAuthenticated(true);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          setIsCanvaAuthenticated(false);
        }
      } 
    };

    fetchCanvaAuthenticate();

    return () => {
      clearTimeout(timeoutId);
      setUnsavedChanges(false);
    };
  }, []);

  useEffect(() => {
    if (isInitialized) {
      fetchTabData();
    }
  }, [activeTab, isCanvaAuthenticated, isInitialized]);

  // Sync URL 'playlist' param with selectedPlaylistId
  useEffect(() => {
    if (!isInitialized) return;
    const currentUrl = new URL(window.location);
    if (selectedPlaylistId) {
      currentUrl.searchParams.set('playlist', selectedPlaylistId);
    } else {
      currentUrl.searchParams.delete('playlist');
    }
    navigate(currentUrl.pathname + currentUrl.search, { replace: true });
  }, [selectedPlaylistId, isInitialized, navigate]);

  useEffect(() => {
    if (playlistData.length > 0 && !playlistData.some(item => item.id === selectedPlaylistId)) {
      setSelectedPlaylistId(playlistData[0]?.id || '');
    }
  }, [playlistData, selectedPlaylistId])

  const fetchPlaylistItems = async () => {
    let res = await API.getPlaylistItems(selectedPlaylistId);
    setPlaylistItems(res.data?.items || []);
    setPlaylistOrderMap({});
    setPlaylistHeader({ id: res.data?.id, name: res.data.name, isLoop: res.data.isLoop });
    console.log("Playlist items fetched:", { id: res.data?.id, name: res.data.name, isLoop: res.data.isLoop });
  };

  useEffect(() => {
    if (selectedPlaylistId) {
      fetchPlaylistItems();
    } else {
      setPlaylistItems([]);
    }
  }, [selectedPlaylistId])

  const handleUnsavedChanges = (onSubmitCallback) => {
    if (playlistOrderMap[selectedPlaylistId]?.length > 0 || (playlistOrderMap[selectedPlaylistId]?.length === 0 && playlistItems?.length > 0)) {
      setNotificationProps((prev) => ({
        icon: Save,
        message: 'CONFIRM_SAVE',
        description: 'CONFIRM_SAVE_BEFORE_EXIT',
        primaryButtonText: 'CONTINUE',
        secondaryButtonText: 'CANCEL',
        showSecondaryButton: true,
        onClose: () => { modalRef.current.hide(); },
        onSubmit: () => {
          modalRef.current.hide();
          onSubmitCallback();
        },
      }));
      modalRef.current.show();
      return true;
    }
    return false;
  };

  const showAddPlaylist = () => {
    if (!handleUnsavedChanges(() => {
      new window.bootstrap.Modal(document.getElementById('addNewPlaylistModal')).show();
    })) {
      new window.bootstrap.Modal(document.getElementById('addNewPlaylistModal')).show();
    }
  };

  const selectPlaylist = (id) => {
    if (!handleUnsavedChanges(() => {
      setSelectedPlaylistId(id);
    })) {
    setSelectedPlaylistId(id);
    }
  };

  const handleDelete = async (id) => {
    try {
      await API.deletePlaylists(id);
      await fetchTabData()
    } catch (error) {
      console.error("Error deleting playlist:", error);
    };
  };

  const handleDeleteMedia = async (id) => {
    try {
      await API.deleteMedia(id);
      await fetchTabData();
      if (!playlistOrderMap[selectedPlaylistId] || playlistOrderMap[selectedPlaylistId]?.length === 0) {
        fetchPlaylistItems();
        return;
      }
      setPlaylistOrderMap((prevMap) => {
        const updatedItems = (prevMap[selectedPlaylistId] || playlistItems).filter(item => item.id !== id) || [];
        return {
          ...prevMap,
          [selectedPlaylistId]: [...updatedItems]
        };
      });
    } catch (error) {
      setError(<FormattedMessage id="DELETE_MEDIA_FAILED" values={{ errorMsg: error.message }} />);
    }
  };

  const getWidgetSubData = (subcategory) => {
    if (activeTab !== SIGNAGE_MEDIA.MEDIA_CATEGORY.WIDGET) return {};
    return widgetData && widgetData.find(item => item.subcategory === subcategory) || {};
  }

  const updatePlaylist = async (update) => {
    await API.updatePlaylist(update);
  };

  const handleToggleLoop = async (checked, id) => {
    try {
      await updatePlaylist({ id, isLoop: checked });
      // Only refresh playlist data, not all tab data
      if (activeTab === 'playlists') {
        const res = await API.getPlaylists();
        setPlaylistData(res.data);
      }
      if (selectedPlaylistId === id) {
        setPlaylistHeader({ ...playlistHeader, isLoop: checked });
      }
    } catch (error) {
      console.error("Error updating playlist loop status:", error);
    };
  }
  const handleDuration = async (id, duration) => {
    try {
      await API.updatePlaylistItem({ id, duration });
      // Only refresh playlist data, not all tab data
      if (activeTab === 'playlists') {
        const res = await API.getPlaylists();
        setPlaylistData(res.data);
      }
    } catch (error) {
      console.error("Error updating playlist loop status:", error);
    };
  }
  const savePlaylist = async () => {
    try {
      if (!playlistOrderMap[selectedPlaylistId] || (!playlistOrderMap[selectedPlaylistId].length && playlistItems.length === 0)) {
        setError(<FormattedMessage id="EDIT_PLAYLIST" />);
        return;
      }

      setIsSaving(true);
      let transformedData = [];
      let items = playlistOrderMap[selectedPlaylistId];
      console.log(items);
      transformedData = items.map((item) => {
        const datum = {
          mediaId: item.id,
          duration: item.duration,
          category: item.category,
          name: item.name,
          content: item.content
        }
        //If data contains tab it has not been entered into our system yet
        if (item.tab && item.tab === 'canva') {
          datum.mediaId = ''
          datum.category = 'canva'
          datum.content = {
            urls: [],
            canvaId: item.id,
            updatedAt: item.updatedAt
          }
        }
        return (datum)
      });
      await API.updatePlaylistItem(selectedPlaylistId, transformedData);
      // Only refresh playlist data, not all tab data
      if (activeTab === 'playlists') {
        const res = await API.getPlaylists();
        setPlaylistData(res.data);
      }
      fetchPlaylistItems();
      setSuccess(<FormattedMessage id="PLAYLIST_SAVE_SUCCESS" />);
    } catch (error) {
      console.error("Error saving playlist:", error);
      setError(<FormattedMessage id="PLAYLIST_SAVE_ERROR" />);
    } finally {
      setIsSaving(false);
    }
  };

  const handleDragStart = (item, tab) => {
    setDraggedItem({ ...item, tab });
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleItemDragOver = (e, idx) => {
    e.preventDefault();
    setDragOverIndex(idx);
  };

  // Drag away from the item
  const handleItemDragLeave = (e) => {
    e.preventDefault();
    setDragOverIndex(null);
  };

  // Drag and drop onto the blank area of the right panel
  const handleDrop = (e) => {
    e.preventDefault();
    if (!draggedItem || !selectedPlaylistId) {
      setDraggedItem(null);
      setDragOverIndex(null);
      return;
    }
    const newItem = { ...draggedItem, duration: draggedItem.duration ? draggedItem.duration : 10, loop: true };
    updatePlaylistOrderMap(newItem);
  };

  const handleItemDrop = (e, idx) => {
    e.preventDefault();
    if (!draggedItem || !selectedPlaylistId) {
      setDraggedItem(null);
      setDragOverIndex(null);
      return;
    }
    const newItem = { ...draggedItem, duration: draggedItem.duration ? draggedItem.duration : 10, loop: true };
    updatePlaylistOrderMap(newItem, idx);
  };

  const updatePlaylistOrderMap = (newItem, idx) => {
    setPlaylistOrderMap((map) => {
      const prevArr = map[selectedPlaylistId] || playlistItems || [];
      let duplicateStatus = -1;
      if (newItem.category === 'canva') {
        prevArr.some((i) => {
          const isIdEqual = i.id === newItem.id || i.content?.canvaId === newItem.id;
          const isUpdatedAtEqual = i.updatedAt === newItem.updatedAt || i.content?.updatedAt === newItem.updatedAt;

          if (isIdEqual && !isUpdatedAtEqual) {
            duplicateStatus = 0;
            return true;
          } else if (isIdEqual && isUpdatedAtEqual) {
            duplicateStatus = 1;
            return true;
          }
          return false; 
        });
        if (duplicateStatus === 1) {
          setDraggedItem(null);
          setDragOverIndex(null);
          return map;
        }
        if (duplicateStatus === 0) {
          const updatedArr = prevArr.map((item) => {
            if (
              (item.id === newItem.id || item.content?.canvaId === newItem.id)
            ) {
              return { ...item, ...newItem };
            }
            return item;
          });
          setDraggedItem(null);
          setDragOverIndex(null);
          return {
            ...map,
            [selectedPlaylistId]: updatedArr,
          };
        }

      } else if (prevArr.some((i) => i.id === newItem.id)) {
        setDraggedItem(null);
        setDragOverIndex(null);
        return map;
      }
      const arr = [...prevArr];
      if (idx !== undefined) {
        arr.splice(idx, 0, newItem);
      } else {
        arr.push(newItem);
      }
      return {
        ...map,
        [selectedPlaylistId]: arr,
      };
    });
    setDraggedItem(null);
    setDragOverIndex(null);
    };

  const updatePlaylistsMedia = (updatedMedia) => {
    if (!playlistOrderMap[selectedPlaylistId] || playlistOrderMap[selectedPlaylistId]?.length === 0) {
      fetchPlaylistItems();
      return;
    }
    setPlaylistOrderMap((map) => {
      const prevArr = map[selectedPlaylistId] || [];
      const newArr = prevArr.map((item) =>
        item.id === updatedMedia.id ? { ...item, ...updatedMedia } : item
      );

      return {
        ...map,
        [selectedPlaylistId]: newArr,
      };
    });
  };

  const [durationMap, setDurationMap] = useState({});

  useEffect(() => {
    if (Array.isArray(playlistData)) {
      const newDurationMap = playlistData.reduce((acc, pl) => ({ ...acc, [pl.id]: sumDurations(pl) }), {});
      setDurationMap(newDurationMap);
    }
  }, [playlistOrderMap, playlistData]);
  
  useEffect(() => {
    props.dispatch(setUnsavedChanges(playlistOrderMap[selectedPlaylistId]?.length > 0 || (playlistOrderMap[selectedPlaylistId]?.length === 0 && playlistItems?.length > 0)));
  }, [playlistOrderMap]);

  // Calculate the parent duration (display only used)
  function sumDurations(items) {
    let arr = [];
    if (items && items.id && playlistOrderMap[items.id]) {
      arr = playlistOrderMap[items.id];
    } else if (Array.isArray(items)) {
      arr = items;
    }
    let totalSeconds = 0;
    arr.forEach(item => {
      totalSeconds += parseInt(item.duration);
    });
    return totalSeconds;
  }

  // When switching tabs, reload the data of the current tab.
  const handleTabChange = (key) => {
    if (key === activeTab) return;
    setActiveTab(key);
    
    // Update URL with the new tab
    const currentUrl = new URL(window.location);
    if (key === 'playlists') {
      // Remove tab parameter for default playlist tab
      currentUrl.searchParams.delete('tab');
    } else {
      // Add or update tab parameter for other tabs
      currentUrl.searchParams.set('tab', key);
    }
    navigate(currentUrl.pathname + currentUrl.search, { replace: true });
  };

  const handleCanvaSignOut = async () => {
    try {
      const res = await API.CanvaSignout();
      console.log(res);
      setIsCanvaAuthenticated(false);
      setCanvaData([]); // Clear Canva data
    } catch (error) {
      console.error("Error signing out from Canva:", error);
      // Even if the API call fails, we should still update the local state
      setIsCanvaAuthenticated(false);
      setCanvaData([]);
    }
  };

  // Helper function to get current tab data
  const getCurrentTabData = () => {
    switch (activeTab) {
      case 'playlists':
        return playlistData;
      case SIGNAGE_MEDIA.MEDIA_CATEGORY.MEDIA:
        return mediaData;
      case SIGNAGE_MEDIA.MEDIA_CATEGORY.CANVA:
        return canvaData;
      case SIGNAGE_MEDIA.MEDIA_CATEGORY.WIDGET:
        return widgetData;
      case SIGNAGE_MEDIA.MEDIA_CATEGORY.LINK:
        return linkData;
      default:
        return [];
    }
  };

  const handleRenameBlur = async (id) => {
    try {
      if (!renameValue.trim()) {
        setRenameId(null);
        setRenameValue('');
        return;
      }
      if ((renameValue.length < 2 || renameValue.length > 36)) {
        setError(<FormattedMessage id="PLAYLIST_NAME_LENGTH" />);
        return;
      }
      await updatePlaylist({ id, name: renameValue });
      setRenameId(null);
      setRenameValue('');
      await fetchTabData();
      if (selectedPlaylistId === id) {
        setPlaylistHeader({ ...playlistHeader, name: renameValue });
      }
    } catch (error) {
      console.error("Error renaming playlist:", error);
      setError(<FormattedMessage id="RENAME_PLAYLIST_FAILED" />);
    }
  };

  return (
    <>
      <Calendar
        setSuccess={setSuccess}
        closeModal={closeModal}
        refreshData={fetchTabData}
        fetchPlaylistItems={fetchPlaylistItems}
        data={getWidgetSubData(SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CALENDAR)}
        updatePlaylistsMedia={updatePlaylistsMedia}
      />
      <Clock
        setSuccess={setSuccess}
        closeModal={closeModal}
        refreshData={fetchTabData}
        fetchPlaylistItems={fetchPlaylistItems}
        data={getWidgetSubData(SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CLOCK)}
        updatePlaylistsMedia={updatePlaylistsMedia}
      />
      <Weather
        setSuccess={setSuccess}
        closeModal={closeModal}
        refreshData={fetchTabData}
        fetchPlaylistItems={fetchPlaylistItems}
        data={getWidgetSubData(SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.WEATHER)}
        updatePlaylistsMedia={updatePlaylistsMedia}
      />
      <AddLink
        setSuccess={setSuccess}
        setError={setError}
        refreshData={fetchTabData}
        closeModal={closeModal}
        linkItem={linkItem}
        setLinkItem={setLinkItem}
        fetchPlaylistItems={fetchPlaylistItems}
        updatePlaylistsMedia={updatePlaylistsMedia}
      />
      <AddNewPlaylist
        setSuccess={setSuccess}
        setError={setError}
        refreshData={fetchTabData}
        closeModal={closeModal}
        setSelectedPlaylistId={setSelectedPlaylistId}
      />
      <ImportFromCanva
        setSuccess={setSuccess}
        setError={setError}
        refreshData={fetchTabData}
        closeModal={closeModal}
      />
      <label className="mes-title">
        <FormattedMessage id="SIGNAGE_CREATE_PLAYLIST" />
      </label>
      <div className="border playlist-main-container">
        <div className="row flex-grow-1" style={{ minHeight: '100%' }}>
          {/* Left side label panel */}
          <div className="col-5 d-flex flex-column border-end px-0 playlist-left-panel h-100" style={{ minHeight: '100%' }}>
            {/* Horizontal tab bar */}
            <PlaylistTabBar tabs={TABS} activeTab={activeTab} onTabChange={handleTabChange} />
            {/* Left content area */}
            <div className="flex-grow-1 w-100 playlist-scroll-area">
              <RenderTabContent
                activeTab={activeTab}
                tabData={getCurrentTabData()}
                selectedPlaylistId={selectedPlaylistId}
                renameId={renameId}
                renameValue={renameValue}
                setRenameId={setRenameId}
                setRenameValue={setRenameValue}
                handleRenameBlur={handleRenameBlur}
                handleToggleLoop={handleToggleLoop}
                durationMap={durationMap}
                handleDelete={handleDelete}
                handleDragStart={handleDragStart}
                setSelectedPlaylistId={setSelectedPlaylistId}
                selectPlaylist={selectPlaylist}
                setLinkItem={setLinkItem}
                handleDeleteMedia={handleDeleteMedia}
                showAddPlaylist={showAddPlaylist}
                isCanvaAuthenticated={isCanvaAuthenticated}
                canvaUrl={canvaUrl}
                isLoading={isLoading}
                isInitialized={isInitialized}
                handleCanvaSignOut={handleCanvaSignOut}
              />
            </div>
          </div>
          {/* Right-side content panel */}
          <div className="col-7 flex-col playlist-right-panel h-100">
            <div className="border-bottom d-flex align-items-center playlist-panel-header">
              <span className="label-bold text-start flex-grow-1">
                <FormattedMessage id="NEW_PLAYLIST" />
              </span>
              <PlaylistHeaderActions
                selectedPlaylistId={selectedPlaylistId}
                tabData={playlistData}
                setPlaylistOrderMap={setPlaylistOrderMap}
                fetchPlaylistList={fetchTabData}
                handleToggleLoop={handleToggleLoop}
                playlistHeader={playlistHeader}
              />
            </div>
            {/* Right panel: Playlist details */}
            <div className="playlist-detail-panel flex-grow-1 d-flex flex-column"
              onDrop={handleDrop}
              onDragOver={handleDragOver}>
              <PlaylistPanelList
                playlistOrderMap={playlistOrderMap}
                setPlaylistOrderMap={setPlaylistOrderMap}
                selectedPlaylistId={selectedPlaylistId}
                playlistItems={playlistItems}
                tabData={playlistData}
                dragOverIndex={dragOverIndex}
                handleItemDragOver={handleItemDragOver}
                handleItemDragLeave={handleItemDragLeave}
                handleItemDrop={handleItemDrop}
                handleDuration={handleDuration}
              />
            </div>
          </div>
        </div>
        <FooterActions
          onLeftClick={() => { setPlaylistOrderMap({}); }}
          onSave={() => { savePlaylist() }}
          leftLabel="CANCEL"
          saveLabel="SAVE_PLAYLIST"
          isSaving={isSaving}
        />
      </div>
      <Toast
        success={success}
        setSuccess={setSuccess}
        error={error}
        setError={setError}
        className={"toast-message"}
      />
      <NotificationModal {...notificationProps} />
    </>
  )
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(SignageCreatePlaylist)